import { createContext } from 'react';

import { PlatformLocalUserWithTeams } from '@cloudquery/api-platform';

import { PlatformPermissions } from '@/constants/platformPermissions';

export interface AuthContextType {
  refetch: () => Promise<void>;
  registered: boolean;
  signInWithEmailAndPassword: (email: string, password: string) => Promise<void>;
  user: PlatformLocalUserWithTeams | undefined;
  userPlatformPermissions: PlatformPermissions[];
  userTeamsPermissions: PlatformPermissions[];
}

const initialAuthState: AuthContextType = {
  refetch: () => Promise.resolve(),
  registered: false,
  signInWithEmailAndPassword: () => Promise.resolve(),
  user: undefined,
  userPlatformPermissions: [PlatformPermissions.GENERAL_READ],
  userTeamsPermissions: [PlatformPermissions.GENERAL_READ],
};

export const AuthContext = createContext<AuthContextType>(initialAuthState);
